import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBSignUpForm from './SBSignUpForm.vue';
import SBRadioGroup from './SBRadioGroup.vue';
import SBRadio from './SBRadio.vue';

@Component({
    components: {
        SBSignUpForm,
        SBRadioGroup,
        SBRadio,
    }
})
export default class SBPaymentMethodSelect extends Mixins(SBComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    public value!: string;

    @Prop({
        type: String,
        default: "",
    })
    public ngPaymentMethod!: string;

    @Emit("input")
    public input(val: string) {
        return val;
    }
}
